@use "../../styles/breakpoints";
@use "../../styles/text";

:host {
  .pagination-control-row {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;

    @include breakpoints.small-up {
      justify-content: center;
    }

    hp6-icon-button {
      display: block;

      &.hidden {
        visibility: hidden;
      }
    }

    hp6-text-select {
      display: block;

      margin-top: var(--spacing-sm);
      margin-bottom: var(--spacing-sm);
      margin-left: auto;
      margin-right: auto;

      @include breakpoints.small-up {
        margin-left: var(--spacing-lg);
        margin-right: var(--spacing-lg);
      }
    }

    .single-page {
      color: var(--color-text-base);
      display: flex;
      flex-direction: row;
      align-items: center;

      margin-top: var(--spacing-sm);
      margin-bottom: var(--spacing-sm);

      .single-page-label {
        margin-right: var(--spacing-xxs);
      }

      &.xxs {
        .single-page-label {
          @include text.text-heading-xxs;
        }

        .single-page-one {
          @include text.text-body-xs;
        }
      }

      &.xs {
        .single-page-label {
          @include text.text-heading-xs;
        }

        .single-page-one {
          @include text.text-body-sm;
        }
      }

      &.sm {
        .single-page-label {
          @include text.text-heading-sm;
        }

        .single-page-one {
          @include text.text-body-md;
        }
      }

      &.md {
        .single-page-label {
          @include text.text-heading-md;
        }

        .single-page-one {
          @include text.text-body-lg;
        }
      }
    }
  }
}
